import _defineProperty from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
import { globalImportUrl } from '../core/request';
/**
 * Get details to display one page of workouts for ride
 * Return details needed to display one page of workouts for a ride. Only includes completed workouts. Can be called with at least one of (workout_id, before, or after) to determine what page of the leaderboard to get. If workout_id and before or after are provided, then the page will be centered by before or after and the workout will be inserted if it is missing from the leaderboard.
 * @param id The ride id
 * @param limit Size of page to return
 * @param workoutId Return a page including the workout with this id. If possible, the page will be centered on this workout. It may not be possible if the workout is too close to the beginning or the end of the leaderboard.
 * @param before Return a page of workouts before the current page (with smaller ranks). This value comes from the "previous" field on the response from the current page.
 * @param after Return a page of workouts after the current page (with larger ranks). This value comes from the "next" field on the response from the current page.
 * @returns any Successful response
 * @throws ApiError
 */

export var getRideLeaderboardWorkoutsDetails = function getRideLeaderboardWorkoutsDetails(api, id, limit, workoutId, before, after) {
  var options = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {};
  var localVarPath = "/stats/v2/ride/".concat(id, "/leaderboard/summary");
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'GET'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};

  if (typeof limit !== 'undefined') {
    localVarQueryParameter['limit'] = limit;
  }

  if (typeof workoutId !== 'undefined') {
    localVarQueryParameter['workout_id'] = workoutId;
  }

  if (typeof before !== 'undefined') {
    localVarQueryParameter['before'] = before;
  }

  if (typeof after !== 'undefined') {
    localVarQueryParameter['after'] = after;
  }

  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Get leaderboard details for a list of workout ids
 * Get details to display for workouts on the leaderboard. A maximum of 250 workout ids at a time are supported.
 * @param requestBody
 * @returns any Successful response
 * @throws ApiError
 */

export var getLeaderboardWorkoutsDetails = function getLeaderboardWorkoutsDetails(api, requestBody) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var localVarPath = "/stats/workouts/details";
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'POST'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  localVarRequestOptions.data = requestBody;
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};